<script lang="ts" setup>
import LayoutDefault from '~/layout/default.vue'
import { useAccountStore } from '../../shared/store/store.account'
import { getCategories, getProfileData } from '@caks/shared/api/user.route'
import uuid4 from 'uuid4'
import { CustomToast } from '@caks/uikit/toast'
import { ElementCart } from '~/components/element'
import { Transition } from 'vue'
import { IconCross } from '@caks/uikit/icon'

const store = useAccountStore()

const showCookies = ref(false)

onMounted(async () => {
  const savedCart = localStorage.getItem('cart')
  const promo = localStorage.getItem('promo')
  const location = localStorage.getItem('location')

  if (savedCart) store.cart = JSON.parse(savedCart)
  if (location) store.selectedLocation = JSON.parse(location)
  if (promo) store.setPromo(JSON.parse(promo))

  const watchedStories = localStorage.getItem('wathed-stories')

  if (watchedStories) {
    const ids: string[] = JSON.parse(watchedStories)
    if (ids) store.watchedStoriesIds = ids.map((el) => +el)
  } else {
    store.watchedStoriesIds = []
  }

  const { data: profileData, status } = await getProfileData()
  if (status === 'OK') {
    store.setProfile(profileData)
  } else {
    if (!sessionStorage.getItem('guestToken')) {
      let uuid = uuid4()

      sessionStorage.setItem('guestToken', `guest_${uuid}`)
    }
  }

  const { data: categoriesData } = await getCategories()
  store.categories = categoriesData.map((el) => {
    return {
      id: el.id,
      name: el.name,
    }
  })

  const coockieIsShow = localStorage.getItem('coockieIsShow')
  if (!coockieIsShow) {
    showCookies.value = true
    localStorage.setItem('coockieIsShow', '1')
  }
})
</script>

<template>
  <client-only>
    <layout-default>
      <router-view />
      <element-cart />
    </layout-default>
    <custom-toast desktop />

    <Transition name="slide-coockie">
      <div v-if="showCookies" class="coockie">
        <p>
          Наш сайт использует файлы cookie для быстрой удобной работы сайта. Продолжая использовать
          сайт, вы соглашаетесь с
          <a href="/Политика ОПС_вер. 17.01.docx" target="_blank">
            политикой обработки персональных данных
          </a>
        </p>
        <button @click="showCookies = false">
          <IconCross />
        </button>
      </div>
    </Transition>
  </client-only>
</template>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.leaflet-control-attribution.leaflet-control {
  display: none;
}
body._locked {
  scrollbar-gutter: stable;
  overflow: hidden;
}
html,
body {
  scrollbar-gutter: stable;
}

.coockie {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: $sub-green;
  padding: 12px 32px;
  color: $primary-green;
  text-align: center;
  @include h5-6;

  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    flex: 1;
  }

  a {
    color: $primary-text;
  }
}

.slide-coockie-enter-active {
  transition: all 0.3s ease-out;
}

.slide-coockie-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-coockie-enter-from,
.slide-coockie-leave-to {
  transform: translateY(48px);
}
</style>
